import { Box } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import upsaleTypes from './data';
import UpsaleTemplate from './template';

const Upsale: React.FC<unknown> = () => {
  const location = useLocation();
  const [type, setType] = useState<string>(location.pathname.split('/')[2]);

  useEffect(() => {
    setType(location.pathname.split('/')[2]);
  }, [location.pathname]);

  return (
    <Box bg="inherit" pl="6" pt="4" h="full">
      <Box bg="white" h="full">
        <UpsaleTemplate {...upsaleTypes[type as keyof typeof upsaleTypes]} />
      </Box>
    </Box>
  );
};

export default Upsale;
